import styled from "styled-components";

export const HtmlWrapper = styled.div`
  margin: 0;
  padding: 0;
`;
